import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const swipeConfidenceThreshold = 10000;
const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity;
};
const Slider = ({ slides }) => {
    const [[page, direction], setPage] = useState([0, 0]);

    if (!slides || slides.length === 0) return null;

    const paginate = (newDirection) => {
        let newPage = page + newDirection;

        if (newPage < 0) newPage = slides.length - 1;
        if (newPage >= slides.length) newPage = 0;

        setPage([newPage, newDirection]);
    };

    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? 300 : -300,
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            x: direction < 0 ? 300 : -300,
            opacity: 0
        })
    };

    return (
        <div className="slider-container">
            <div className="slider-frame">
                <AnimatePresence initial={false} custom={direction}>
                    <motion.img
                        key={page}
                        src={`/HomeSlider/${slides[page].Slide_Image}`}
                        alt={`Slide ${page}`}
                        custom={direction}
                        variants={variants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{
                            x: { type: "spring", stiffness: 300, damping: 30 },
                            opacity: { duration: 0.2 }
                        }}
                        drag="x"
                        dragConstraints={{ left: 0, right: 0 }}
                        dragElastic={0.8}
                        onDragEnd={(e, { offset, velocity }) => {
                            const swipe = swipePower(offset.x, velocity.x);

                            if (swipe < -swipeConfidenceThreshold) {
                                paginate(1);
                            } else if (swipe > swipeConfidenceThreshold) {
                                paginate(-1);
                            }
                        }}
                        className="slider-image"
                    />
                </AnimatePresence>
            </div>

            {/* Arrows */}
            <button className="arrow left" onClick={() => paginate(-1)}>
                ›
            </button>
            <button className="arrow right" onClick={() => paginate(1)}>

                ‹
            </button>

            {/* Dots */}
            <div className="slider-dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        onClick={() => setPage([index, index > page ? 1 : -1])}
                        className={`dot ${index === page ? "active" : ""}`}
                    />
                ))}
            </div>
        </div >
    );
};

export default Slider;